import { render, staticRenderFns } from "./ProfileMegacardWidget.vue?vue&type=template&id=7938f162&scoped=true&"
import script from "./ProfileMegacardWidget.vue?vue&type=script&lang=ts&"
export * from "./ProfileMegacardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileMegacardWidget.vue?vue&type=style&index=0&id=7938f162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938f162",
  null
  
)

export default component.exports